import * as React from 'react';

import { SHORT_DATE_ONLY_DISPLAY, formatDateTimeDisplay } from 'js/utils/DateTimeUtils';

import { Typography, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/degree-home';

interface Props {
  // String like: "2023-05-02T13:10:32.430Z"
  nextEnrollmentPeriod: string;
}
const EnrollmentPeriodEnded = ({ nextEnrollmentPeriod, ...styleProps }: Props) => {
  const formattedDate = formatDateTimeDisplay(nextEnrollmentPeriod, SHORT_DATE_ONLY_DISPLAY);
  return (
    <div {...styleProps}>
      {/* eslint-disable-next-line @coursera-web/custom-rules/prefer-cds-typography2 -- FIXME: legacy; migrate to Typography2 */}
      <Typography variant="h2semibold">{_t('Enrollment for-credit not available at this time')}</Typography>
      <Typography2 component="p">
        {_t('The next enrollment period for-credit starts on #{formattedDate}', { formattedDate })}
      </Typography2>
    </div>
  );
};

export default EnrollmentPeriodEnded;
